
import { Component, Prop, Vue } from 'vue-property-decorator';
import type { RainfallRow } from '../../model';

@Component
export default class BulkRainfallOperation extends Vue {
  @Prop({ required: true })
  data!: RainfallRow[];

  selectedDams: string[] = [];

  operationMode = 'multiply';

  // 倍率操作
  multiplyValue = 2;

  multiplyStartHour = 1;

  multiplyEndHour = 96;

  // 一定値に変更
  fixedValue = 2;

  fixedStartHour = 1;

  fixedEndHour = 96;

  showErrorDialog = false;

  errorMessage = '';

  get availableDams() {
    const firstRow = this.data[0];
    if (!firstRow) return [];
    return firstRow.dams.map(dam => ({
      id: dam.id,
      // 単位部分（[...]）を除去
      label: dam.label.replace(/\s*\[.*\]$/, ''),
    }));
  }

  applyMultiply() {
    if (!this.selectedDams.length) {
      this.showError('ダムを選択してください');
      return;
    }

    const startIndex = this.multiplyStartHour;
    const endIndex = this.multiplyEndHour;

    this.data.forEach((row, rowIndex) => {
      if (rowIndex >= startIndex && rowIndex <= endIndex) {
        row.dams.forEach(dam => {
          if (this.selectedDams.includes(dam.id)) {
            const afterValue = typeof dam.after === 'string' ? parseFloat(dam.after) : dam.after;
            const newValue = afterValue * this.multiplyValue;
            // eslint-disable-next-line no-param-reassign
            dam.after = newValue;
          }
        });
      }
    });

    this.$emit('updated');
  }

  applyFixed() {
    if (!this.selectedDams.length) {
      this.showError('ダムを選択してください');
      return;
    }

    const startIndex = this.fixedStartHour;
    const endIndex = this.fixedEndHour;

    this.data.forEach((row, rowIndex) => {
      if (rowIndex >= startIndex && rowIndex <= endIndex) {
        row.dams.forEach(dam => {
          if (this.selectedDams.includes(dam.id)) {
            // eslint-disable-next-line no-param-reassign
            dam.after = this.fixedValue;
          }
        });
      }
    });

    this.$emit('updated');
  }

  applyClear() {
    if (!this.selectedDams.length) {
      this.showError('ダムを選択してください');
      return;
    }

    this.data.forEach(row => {
      row.dams.forEach(dam => {
        if (this.selectedDams.includes(dam.id)) {
          // eslint-disable-next-line no-param-reassign
          dam.after = dam.before;
        }
      });
    });

    this.$emit('updated');
  }

  showError(message: string) {
    this.errorMessage = message;
    this.showErrorDialog = true;
  }
}
